import sber from "../../assets/sber.png";
import ymoney from "../../assets/ymoney.png";
import tpay from "../../assets/t-pay.png";

interface PaymentMethodConfig {
  keywords: string[];
  displayName: string;
  logo: string;
}

export const paymentMethodsConfig: PaymentMethodConfig[] = [
  {
    keywords: ["sber", "сбер"],
    displayName: "Сбер Pay",
    logo: sber,
  },
  {
    keywords: ["yoomoney", "ymoney", "ю money"],
    displayName: "Ю Money",
    logo: ymoney,
  },
  {
    keywords: ["tinkoff", "t-pay", "тинькофф"],
    displayName: "T-Pay",
    logo: tpay,
  },
];
